export default __webpack_public_path__ + "static/media/More.42d7984e.svg";